/**
 * Bot Flow Module — API service for Phase 1 deterministic flow builder.
 * Backend endpoints under /api/bot.
 */
import axiosConfig from '../../../config/axiosConfig';

const get  = (path, config) => axiosConfig.get(path, config);
const post = (path, body)   => axiosConfig.post(path, body || {});
const put  = (path, body)   => axiosConfig.put(path, body);
const del  = (path)         => axiosConfig.delete(path);

export const botFlowApi = {
  // Flows
  listFlows:    ()                       => get('/bot/flows'),
  getFlow:      (flowId)                 => get(`/bot/flows/${flowId}`),
  createFlow:   (body)                   => post('/bot/flows', body),
  updateFlow:   (flowId, body)           => put(`/bot/flows/${flowId}`, body),
  saveGraph:    (flowId, body)           => put(`/bot/flows/${flowId}/graph`, body),
  generateFlow: (prompt)                 => post('/bot/flows/ai-generate', { prompt }),
  previewApiCall: (body)                 => post('/bot/api-call-preview', body),
  deleteFlow:   (flowId)                 => del(`/bot/flows/${flowId}`),
  activate:     (flowId)                 => post(`/bot/flows/${flowId}/activate`),
  deactivate:   (flowId)                 => post(`/bot/flows/${flowId}/deactivate`),

  // Nodes
  listNodes:    (flowId)                 => get(`/bot/flows/${flowId}/nodes`),
  createNode:   (flowId, body)           => post(`/bot/flows/${flowId}/nodes`, body),
  updateNode:   (flowId, nodeId, body)   => put(`/bot/flows/${flowId}/nodes/${nodeId}`, body),
  deleteNode:   (flowId, nodeId)         => del(`/bot/flows/${flowId}/nodes/${nodeId}`),

  // Edges
  listEdges:    (flowId)                 => get(`/bot/flows/${flowId}/edges`),
  createEdge:   (flowId, body)           => post(`/bot/flows/${flowId}/edges`, body),
  deleteEdge:   (flowId, edgeId)         => del(`/bot/flows/${flowId}/edges/${edgeId}`),

  // Templates (Phase 2 — flow template library)
  listTemplates:          (params)       => get('/bot/flow-templates', { params }),
  listTemplateCategories: ()             => get('/bot/flow-templates/categories'),
  cloneTemplate:          (slug, body)   => post(`/bot/flow-templates/${slug}/clone`, body),
  resetToDefault:         (flowId)       => post(`/bot/flows/${flowId}/reset-to-default`),
};
